
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/select-store",
      function () {
        return require("private-next-pages/select-store/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/select-store"])
      });
    }
  